import { Suspense } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

export default function MesafeliSatisPage() {
  return (
    <Suspense fallback={<div>Yükleniyor...</div>}>
      <div className="min-h-screen bg-gradient-to-b from-white via-primary-light/10 to-white">
        <Navbar />
        
        {/* Hero Section */}
        <section className="pt-32 pb-16 px-6">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="font-serif text-4xl md:text-5xl font-bold text-primary-dark mb-4">
              Mesafeli Satış Sözleşmesi
            </h1>
            <p className="text-lg text-gray-600">
              6502 Sayılı Tüketicinin Korunması Hakkında Kanun Uyarınca
            </p>
            <p className="text-base text-gray-500 mt-2">
              Son Güncelleme: {new Date().toLocaleDateString('tr-TR', { year: 'numeric', month: 'long', day: 'numeric' })}
            </p>
          </div>
        </section>

        {/* Content Section */}
        <section className="pb-20 px-6">
          <div className="max-w-4xl mx-auto bg-white rounded-3xl shadow-lg p-8 md:p-12">
            
            <div className="space-y-8">
              {/* Section 1 */}
              <div>
                <h2 className="font-serif text-2xl font-bold text-primary-dark mb-4 flex items-center">
                  <span className="w-2 h-8 bg-gold rounded-full mr-3"></span>
                  1. Taraflar
                </h2>
                <div className="space-y-4">
                  <div className="bg-primary-light/20 rounded-2xl p-6">
                    <h3 className="font-bold text-primary-dark mb-3">SATICI BİLGİLERİ</h3>
                    <div className="space-y-2 text-gray-700">
                      <p><strong>Ünvan:</strong> Deniz Erin</p>
                      <p><strong>Adres:</strong> [Adres Bilgisi]</p>
                      <p><strong>Telefon:</strong> +90 XXX XXX XX XX</p>
                      <p><strong>E-posta:</strong> info@denizerin.com</p>
                      <p><strong>Web Sitesi:</strong> www.denizerin.com</p>
                    </div>
                  </div>
                  <div className="bg-gold/10 rounded-2xl p-6">
                    <h3 className="font-bold text-primary-dark mb-3">ALICI BİLGİLERİ</h3>
                    <p className="text-gray-700">
                      Hizmet satın alan kişinin ad, soyad, adres, telefon ve e-posta bilgileri sipariş sırasında alınacak ve sözleşmenin ayrılmaz bir parçası olacaktır.
                    </p>
                  </div>
                </div>
              </div>

              {/* Section 2 */}
              <div>
                <h2 className="font-serif text-2xl font-bold text-primary-dark mb-4 flex items-center">
                  <span className="w-2 h-8 bg-gold rounded-full mr-3"></span>
                  2. Sözleşme Konusu
                </h2>
                <p className="text-gray-700 leading-relaxed">
                  İşbu sözleşmenin konusu, SATICI'nın web sitesi üzerinden elektronik ortamda ALICI'ya sunduğu astrolojik danışmanlık, spiritüel danışmanlık, şifa ve enerji çalışmaları ile eğitim hizmetlerinin satışı ve teslimi ile ilgili olarak 6502 sayılı Tüketicinin Korunması Hakkında Kanun ve Mesafeli Sözleşmeler Yönetmeliği hükümleri gereğince tarafların hak ve yükümlülüklerinin belirlenmesidir.
                </p>
              </div>

              {/* Section 3 */}
              <div>
                <h2 className="font-serif text-2xl font-bold text-primary-dark mb-4 flex items-center">
                  <span className="w-2 h-8 bg-gold rounded-full mr-3"></span>
                  3. Hizmet Bilgileri
                </h2>
                <p className="text-gray-700 leading-relaxed mb-3">
                  Satın alınan hizmetin türü, içeriği, süresi, ücreti ve ödeme şekli sipariş özeti sayfasında detaylı olarak belirtilmektedir. ALICI, sipariş vermeden önce bu bilgileri okuduğunu ve onayladığını kabul eder.
                </p>
                <div className="space-y-3">
                  <div className="border-l-4 border-gold pl-4">
                    <h3 className="font-bold text-primary-dark mb-1">Astrolojik Danışmanlık Hizmetleri</h3>
                    <p className="text-gray-700 text-sm">Doğum haritası analizi, transit analizi, sinastri, yıllık öngörü ve kariyer danışmanlığı</p>
                  </div>
                  <div className="border-l-4 border-gold pl-4">
                    <h3 className="font-bold text-primary-dark mb-1">Spiritüel Danışmanlık Hizmetleri</h3>
                    <p className="text-gray-700 text-sm">Ruhsal rehberlik, yaşam amacı keşfi, içsel dönüşüm danışmanlığı, rüya yorumlama</p>
                  </div>
                  <div className="border-l-4 border-gold pl-4">
                    <h3 className="font-bold text-primary-dark mb-1">Şifa & Enerji Çalışmaları</h3>
                    <p className="text-gray-700 text-sm">Enerji şifa seansı, çakra dengeleme, frekans çalışması, uzaktan şifa</p>
                  </div>
                  <div className="border-l-4 border-gold pl-4">
                    <h3 className="font-bold text-primary-dark mb-1">Eğitim Programları</h3>
                    <p className="text-gray-700 text-sm">Astroloji eğitimi, spiritüel gelişim programları, enerji çalışmaları eğitimi</p>
                  </div>
                </div>
              </div>

              {/* Section 4 */}
              <div>
                <h2 className="font-serif text-2xl font-bold text-primary-dark mb-4 flex items-center">
                  <span className="w-2 h-8 bg-gold rounded-full mr-3"></span>
                  4. Genel Hükümler
                </h2>
                <ul className="list-disc list-inside space-y-2 text-gray-700 ml-4">
                  <li>ALICI, web sitesinde sözleşme konusu hizmetin temel nitelikleri, satış fiyatı, ödeme şekli ve ön bilgileri okuyup bilgi sahibi olduğunu ve elektronik ortamda gerekli teyidi verdiğini beyan eder.</li>
                  <li>Sözleşme konusu hizmet, yasal süreyi aşmamak koşulu ile her bir hizmetin özelliğine bağlı olarak ALICI'nın yerleşim yerinin uzaklığı dikkate alınarak belirlenen süre içinde teslim edilir.</li>
                  <li>Hizmet ALICI'dan başka bir kişi/kuruluşa teslim edilecek ise, teslim edilecek kişi/kuruluşun teslimatı kabul etmemesinden SATICI sorumlu tutulamaz.</li>
                  <li>SATICI, sözleşme konusu hizmetin sağlıklı, eksiksiz ve sipariş sırasında belirtilen niteliklere uygun olarak sunulmasından sorumludur.</li>
                </ul>
              </div>

              {/* Section 5 */}
              <div>
                <h2 className="font-serif text-2xl font-bold text-primary-dark mb-4 flex items-center">
                  <span className="w-2 h-8 bg-gold rounded-full mr-3"></span>
                  5. Cayma Hakkı
                </h2>
                <div className="bg-gold/10 border-l-4 border-gold rounded-lg p-6 mb-4">
                  <p className="text-gray-700 leading-relaxed mb-3">
                    <strong className="text-primary-dark">ALICI</strong>, hizmetin sunumuna başlanmadan önce 14 (on dört) gün içinde herhangi bir gerekçe göstermeksizin ve cezai şart ödemeksizin sözleşmeden cayma hakkına sahiptir.
                  </p>
                </div>
                <p className="text-gray-700 leading-relaxed mb-3">
                  <strong>Cayma hakkı süresi:</strong>
                </p>
                <ul className="list-disc list-inside space-y-2 text-gray-700 ml-4 mb-4">
                  <li>Hizmet sunumuna ilişkin sözleşmelerde, sözleşmenin kurulduğu günden itibaren 14 (on dört) gün içinde kullanılabilir.</li>
                  <li>Cayma hakkının kullanılması için bu süre içinde SATICI'ya yazılı olarak veya kalıcı veri saklayıcısı ile bildirimde bulunulması yeterlidir.</li>
                </ul>
                <div className="bg-primary-light/20 rounded-2xl p-6 mb-4">
                  <h3 className="font-bold text-primary-dark mb-3">Cayma Hakkı Bildirimi İçin İletişim:</h3>
                  <div className="space-y-2 text-gray-700">
                    <p><strong>E-posta:</strong> info@denizerin.com</p>
                    <p><strong>Telefon:</strong> +90 XXX XXX XX XX</p>
                    <p><strong>Adres:</strong> [Adres Bilgisi]</p>
                  </div>
                </div>
                <p className="text-gray-700 leading-relaxed mb-3">
                  <strong>Cayma hakkının kullanılamayacağı durumlar:</strong>
                </p>
                <ul className="list-disc list-inside space-y-2 text-gray-700 ml-4">
                  <li>ALICI'nın onayı ile ifasına başlanan hizmetlere ilişkin sözleşmeler (Randevu tarihi gelmiş ve seans gerçekleşmiş hizmetler)</li>
                  <li>Cayma hakkı süresi sona ermeden önce, ALICI'nın onayı ile ifasına başlanan hizmetler</li>
                  <li>Elektronik ortamda anında ifa edilen hizmetler veya tüketiciye anında teslim edilen gayrimaddi mallar (Dijital içerikler, online eğitimler)</li>
                </ul>
              </div>

              {/* Section 6 */}
              <div>
                <h2 className="font-serif text-2xl font-bold text-primary-dark mb-4 flex items-center">
                  <span className="w-2 h-8 bg-gold rounded-full mr-3"></span>
                  6. Ödeme ve Teslimat
                </h2>
                <p className="text-gray-700 leading-relaxed mb-3">
                  <strong>Ödeme Yöntemleri:</strong>
                </p>
                <ul className="list-disc list-inside space-y-2 text-gray-700 ml-4 mb-4">
                  <li>Kredi Kartı / Banka Kartı</li>
                  <li>Havale / EFT</li>
                  <li>Diğer güvenli ödeme yöntemleri</li>
                </ul>
                <p className="text-gray-700 leading-relaxed mb-3">
                  <strong>Hizmet Sunumu:</strong>
                </p>
                <ul className="list-disc list-inside space-y-2 text-gray-700 ml-4">
                  <li>Online seanslar: Belirlenen tarih ve saatte video konferans yoluyla gerçekleştirilir</li>
                  <li>Yüz yüze seanslar: Belirlenen adres ve zamanda gerçekleştirilir</li>
                  <li>Raporlar: Ödeme onayından sonra belirtilen süre içinde e-posta yoluyla teslim edilir</li>
                  <li>Eğitimler: Kayıt onayından sonra erişim bilgileri e-posta ile gönderilir</li>
                </ul>
              </div>

              {/* Section 7 */}
              <div>
                <h2 className="font-serif text-2xl font-bold text-primary-dark mb-4 flex items-center">
                  <span className="w-2 h-8 bg-gold rounded-full mr-3"></span>
                  7. Randevu İptali ve Değişikliği
                </h2>
                <ul className="list-disc list-inside space-y-2 text-gray-700 ml-4">
                  <li>ALICI, randevu tarihinden en az 24 saat önce bildirimde bulunarak randevusunu iptal edebilir veya değiştirebilir.</li>
                  <li>24 saatten daha kısa sürede yapılan iptal taleplerinde iade yapılmaz, ancak randevu başka bir tarihe ertelenebilir.</li>
                  <li>SATICI'nın kontrolü dışındaki sebeplerle randevu gerçekleştirilemezse, ALICI'ya alternatif tarih önerilir veya tam iade yapılır.</li>
                  <li>ALICI'nın randevuya katılmaması durumunda (no-show), ödeme iade edilmez.</li>
                </ul>
              </div>

              {/* Section 8 */}
              <div>
                <h2 className="font-serif text-2xl font-bold text-primary-dark mb-4 flex items-center">
                  <span className="w-2 h-8 bg-gold rounded-full mr-3"></span>
                  8. Sorumluluk Sınırlaması
                </h2>
                <div className="bg-gold/10 border-l-4 border-gold rounded-lg p-6">
                  <p className="text-gray-700 leading-relaxed mb-3">
                    <strong className="text-primary-dark">ÖNEMLİ UYARI:</strong>
                  </p>
                  <ul className="list-disc list-inside space-y-2 text-gray-700 ml-4">
                    <li>Sunulan hizmetler tıbbi, psikolojik veya hukuki danışmanlık yerine geçmez.</li>
                    <li>Astrolojik ve spiritüel danışmanlık hizmetleri, kişisel gelişim ve farkındalık amaçlıdır.</li>
                    <li>Sağlık sorunları için mutlaka tıbbi destek alınmalıdır.</li>
                    <li>Psikolojik rahatsızlıklar için profesyonel psikolojik destek alınmalıdır.</li>
                    <li>Hukuki konularda avukat veya hukuk danışmanına başvurulmalıdır.</li>
                    <li>SATICI, ALICI'nın hizmetlerden beklediği sonuçları garanti etmez.</li>
                  </ul>
                </div>
              </div>

              {/* Section 9 */}
              <div>
                <h2 className="font-serif text-2xl font-bold text-primary-dark mb-4 flex items-center">
                  <span className="w-2 h-8 bg-gold rounded-full mr-3"></span>
                  9. Gizlilik
                </h2>
                <p className="text-gray-700 leading-relaxed">
                  SATICI, ALICI'nın kişisel bilgilerini ve seans içeriklerini gizli tutmayı taahhüt eder. Kişisel verilerin işlenmesi ve korunması hakkında detaylı bilgi için Gizlilik Politikası ve KVKK Aydınlatma Metni'ni inceleyiniz.
                </p>
              </div>

              {/* Section 10 */}
              <div>
                <h2 className="font-serif text-2xl font-bold text-primary-dark mb-4 flex items-center">
                  <span className="w-2 h-8 bg-gold rounded-full mr-3"></span>
                  10. Uyuşmazlık Çözümü
                </h2>
                <p className="text-gray-700 leading-relaxed mb-3">
                  İşbu sözleşmeden doğabilecek ihtilaflarda, Sanayi ve Ticaret Bakanlığı'nca her yıl Aralık ayında belirlenen parasal sınırlar dahilinde tüketicinin yerleşim yerinin bulunduğu veya tüketici işleminin yapıldığı yerdeki Tüketici Hakem Heyetleri ile Tüketici Mahkemeleri yetkilidir.
                </p>
                <div className="bg-primary-light/20 rounded-2xl p-6">
                  <p className="text-gray-700 mb-2">
                    <strong>Parasal Sınırlar (2024 yılı için):</strong>
                  </p>
                  <ul className="list-disc list-inside space-y-1 text-gray-700 ml-4">
                    <li>İl Tüketici Hakem Heyetleri: 92.650 TL'ye kadar</li>
                    <li>İlçe Tüketici Hakem Heyetleri: 30.880 TL'ye kadar</li>
                  </ul>
                </div>
              </div>

              {/* Section 11 */}
              <div>
                <h2 className="font-serif text-2xl font-bold text-primary-dark mb-4 flex items-center">
                  <span className="w-2 h-8 bg-gold rounded-full mr-3"></span>
                  11. Yürürlük
                </h2>
                <p className="text-gray-700 leading-relaxed">
                  ALICI, web sitesinden sipariş verdiği takdirde işbu sözleşme hükümlerini kabul etmiş sayılır. İşbu sözleşme, ALICI tarafından elektronik ortamda onaylandığı tarihte yürürlüğe girer ve taraflar arasında bağlayıcı olur.
                </p>
              </div>

              {/* Section 12 */}
              <div>
                <h2 className="font-serif text-2xl font-bold text-primary-dark mb-4 flex items-center">
                  <span className="w-2 h-8 bg-gold rounded-full mr-3"></span>
                  12. İletişim
                </h2>
                <p className="text-gray-700 leading-relaxed mb-3">
                  Sözleşme ile ilgili her türlü soru, talep ve şikayetleriniz için:
                </p>
                <div className="bg-primary-light/20 rounded-2xl p-6 space-y-2">
                  <p className="text-gray-700"><strong>E-posta:</strong> info@denizerin.com</p>
                  <p className="text-gray-700"><strong>Telefon:</strong> +90 XXX XXX XX XX</p>
                  <p className="text-gray-700"><strong>Adres:</strong> [Adres Bilgisi]</p>
                  <p className="text-gray-700"><strong>Çalışma Saatleri:</strong> Hafta içi 09:00 - 18:00</p>
                </div>
              </div>

              {/* Confirmation */}
              <div className="bg-gold/10 border-2 border-gold rounded-2xl p-6 mt-8">
                <p className="text-gray-700 leading-relaxed">
                  <strong className="text-primary-dark text-lg">ONAY:</strong><br/>
                  İşbu Mesafeli Satış Sözleşmesi'ni okudum, anladım ve elektronik ortamda onaylıyorum. Cayma hakkı, ödeme koşulları ve diğer tüm hükümleri kabul ediyorum.
                </p>
              </div>
            </div>
          </div>
        </section>

        <Footer />
      </div>
    </Suspense>
  );
}